module.exports = __webpack_public_path__ + "img/ryvyl.6af0ddfb.png";